module.exports = __webpack_public_path__ + "img/notice.0eb71d3.png";